export default class RequestPayload {
}



// WEBPACK FOOTER //
// ./~/slotworks/model/gameplay/requests/request-payload.ts